export const KEY_PROGRESS = 'KEY_PROGRESS'
